import { Card } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { TrendingUp, TrendingDown, Minus, Mail, Bell, Calendar } from "lucide-react"

const problems = [
  {
    rank: 1,
    title: "Проблема с оформлением заказа",
    tickets: 47,
    customers: 32,
    revenue: "$23,000",
    trend: "up",
    started: "3 дня назад",
  },
  {
    rank: 2,
    title: "Медленная загрузка каталога",
    tickets: 23,
    customers: 19,
    revenue: "$11,000",
    trend: "stable",
    started: "5 дней назад",
  },
  {
    rank: 3,
    title: "Непонятные условия подписки",
    tickets: 18,
    customers: 16,
    revenue: "$7,500",
    trend: "down",
    started: "2 недели назад",
  },
]

export function WeeklyDigestDemo() {
  return (
    <Card className="bg-card p-4 lg:p-6">
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-primary/10 flex h-10 w-10 items-center justify-center rounded-full">
            <Mail className="text-primary h-5 w-5" />
          </div>
          <div>
            <h3 className="text-foreground font-semibold">Еженедельный дайджест</h3>
            <p className="text-muted-foreground text-sm">11-17 ноября 2024</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Calendar className="text-muted-foreground h-4 w-4" />
          <span className="text-muted-foreground text-sm">Каждый понедельник</span>
        </div>
      </div>

      {/* Stats summary */}
      <div className="mb-6 grid grid-cols-3 gap-4">
        <div className="bg-muted/50 rounded-lg p-3 text-center">
          <div className="text-foreground text-2xl font-semibold">312</div>
          <div className="text-muted-foreground text-xs">Обращений</div>
        </div>
        <div className="bg-muted/50 rounded-lg p-3 text-center">
          <div className="text-foreground text-2xl font-semibold">24</div>
          <div className="text-muted-foreground text-xs">Проблем</div>
        </div>
        <div className="bg-destructive/10 rounded-lg p-3 text-center">
          <div className="text-destructive text-2xl font-semibold">5</div>
          <div className="text-muted-foreground text-xs">Критических</div>
        </div>
      </div>

      {/* Top problems */}
      <div className="mb-4 flex items-center gap-2">
        <Bell className="text-primary h-4 w-4" />
        <h4 className="text-foreground text-sm font-medium">Топ-3 проблемы по влиянию</h4>
      </div>
      <div className="flex flex-col gap-3">
        {problems.map((problem) => (
          <div
            key={problem.rank}
            className="bg-muted/30 flex flex-col gap-2 rounded-lg p-3 sm:flex-row sm:items-center sm:justify-between"
          >
            <div className="flex items-start gap-3">
              <span className="bg-primary text-primary-foreground flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-medium">
                {problem.rank}
              </span>
              <div>
                <p className="text-foreground text-sm font-medium">{problem.title}</p>
                <p className="text-muted-foreground text-xs">
                  {problem.tickets} обращений • {problem.customers} клиентов • {problem.revenue}/мес
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 pl-9 sm:pl-0">
              {problem.trend === "up" && (
                <Badge variant="destructive" className="gap-1">
                  <TrendingUp className="h-3 w-3" />
                  Растёт
                </Badge>
              )}
              {problem.trend === "stable" && (
                <Badge variant="secondary" className="gap-1">
                  <Minus className="h-3 w-3" />
                  Стабильно
                </Badge>
              )}
              {problem.trend === "down" && (
                <Badge variant="outline" className="gap-1 border-green-500 text-green-600">
                  <TrendingDown className="h-3 w-3" />
                  Снижается
                </Badge>
              )}
            </div>
          </div>
        ))}
      </div>
    </Card>
  )
}
